export const Primary = "primary"
export const Secondary = "secondary"
export const Success = "success"
export const Danger = "danger"
export const Warning = "warning"
export const Info = "info"
export const Light = "light"
export const Dark = "dark"
export const OutlineSecondary = "outline-secondary"
